var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgClock2 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reloj-de-pared",
    width: 24.719,
    height: 24.719,
    viewBox: "0 0 24.719 24.719",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M12.36,0a12.36,12.36,0,1,0,12.36,12.36A12.374,12.374,0,0,0,12.36,0Zm0,22.915A10.555,10.555,0,1,1,22.915,12.359,10.567,10.567,0,0,1,12.36,22.915Z",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(10.856 6.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M230.571,131.512h-3.909V126.1a.9.9,0,1,0-1.8,0v6.315a.9.9,0,0,0,.9.9h4.811a.9.9,0,1,0,0-1.8Z",
    transform: "translate(-224.857 -125.197)",
    fill: "currentColor"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock2.9f446d1a.svg";
export { ForwardRef as ReactComponent };